import { SubscriptionState } from "../types";

const state: SubscriptionState = {
  cards: [],
  invoices: [],
  currentSubscriptionPlan: {
    amlEnabled: false,
    amlQuota: 0,
    billingCurrencyCode: "",
    billingInterval: "",
    baseBillingUnitAmount: 0,
    enabled: true,
    id: "",
    name: "",
    stripePriceId: "",
    tier: 0,
    verificationEnabled: true,
    verificationQuota: 0,
  },
  plans: [
    {
      amlEnabled: false,
      amlQuota: 0,
      billingCurrencyCode: "",
      billingInterval: "",
      baseBillingUnitAmount: 0,
      enabled: true,
      id: "",
      name: "",
      stripePriceId: "",
      tier: 0,
      verificationEnabled: true,
      verificationQuota: 0,
    },
  ],
  isSandbox: false,
  verificationQuota: 0,
  verificationQuotaUsed: 0,
  amlQuota: 0,
  amlQuotaUsed: 0,
  quotaExpirationDate: "",
  quotaStartDate: "",
  mode: 0,
  pricePerVerification: 0.0,
  hasPepEnabled: false,
  hasSanctionEnabled: false,
  hasKybEnabled: false,
};

export default state;
